import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20aae3df"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "accordion-item" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["data-bs-target", "aria-controls"]
const _hoisted_5 = ["id", "aria-labelledby"]

import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAccordion',
  props: {
  // 初期表示有無
  show: {
    type: Boolean,
    default: false,
  },
  // アコーディオンのid
  accordionId: {
    type: String,
    default: '',
  },
  // アコーディオンの表示文言
  headerTitle: {
    type: String,
    default: '',
  },
  // アコーディオンヘッダー部の表示カスタマイズクラス(色、背景色、padding等)
  headerStyle: {
    type: String,
    default: undefined,
  },
  // アコーディオンの展開文言のカスタマイズクラス
  bodyStyle: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props

log.trace(`BaseAccordion setup start.`)

// body部クラスデフォルト値
const bodyClassDefault = 'accordion-collapse collapse'

// プロパティ定義

// ヘッダーID
const headerId = props.accordionId ? `${props.accordionId}Header` : ''
// bodyID
const bodyId = props.accordionId ? `${props.accordionId}Body` : ''
// アコーディオンIDターゲット
const targetAccordionId = `#${props.accordionId}`
// bodyidターゲット
const targetBodyId = bodyId ? `#${bodyId}` : ''
// bodyクラス展開状態
const bodyClassValue = props.show ? `${bodyClassDefault} show` : `${bodyClassDefault}`

log.trace(`BaseAccordion setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "accordion py-1",
    id: props.accordionId,
    "data-test": "accordion_parent"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        class: "accordion-header",
        id: _unref(headerId),
        "data-test": "accordion_header"
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["accordion-button collapsed", props.headerStyle]),
          "data-bs-toggle": "collapse",
          "data-bs-target": _unref(targetBodyId),
          "aria-expanded": "false",
          "aria-controls": _unref(bodyId),
          "data-test": "accordion_header_button"
        }, _toDisplayString(props.headerTitle), 11, _hoisted_4)
      ], 8, _hoisted_3),
      _createElementVNode("div", {
        id: _unref(bodyId),
        class: _normalizeClass(_unref(bodyClassValue)),
        "aria-labelledby": _unref(headerId),
        "data-bs-parent": targetAccordionId,
        "data-test": "accordion_body_parent"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["accordion-body", props.bodyStyle]),
          "data-test": "accordion_body"
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 10, _hoisted_5)
    ])
  ], 8, _hoisted_1))
}
}

})